import { Component, ViewContainerRef, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {
    private config: {version: string};
    subscription: Subscription;

    constructor(private router: Router,private httpClient: HttpClient) {
    }

    ngOnInit() {
        // this.config = require('../assets/data/config.json');
        // const headers = new HttpHeaders()
        // .set('Cache-Control', 'no-cache')
        // .set('Pragma', 'no-cache');
        // this.httpClient.get<{version: string}>('../assets/data/config.json',{headers})
        // .subscribe(config => {
        //     if (config.version !== this.config.version) {
        //         this.httpClient
        //         .get("", { headers, responseType: "text" })
        //         .subscribe(() => location.reload());
        //       }
        // });
        this.subscription = this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd)
            )
            .subscribe(() => window.scrollTo(0, 0));
    }


    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }



}